import { style } from "@primeuix/styles/editor";
import BaseStyle from "@primevue/core/base/style";

// this is dumb
const classes = {
  root: ({ instance, state }: {instance: any, state: any}) => [
    "p-editor",
    {
      "p-invalid": instance.$invalid,
      "p-inputwrapper-filled": instance.$filled,
      "p-inputwrapper-focus": state.focused,
      "p-focus": state.focused,
    }
  ],
  toolbar: "p-editor-toolbar",
  content: "p-editor-content"
};

// @ts-expect-error
export default BaseStyle.extend({
  name: "editor",
  style,
  classes
});
